import { connect } from 'react-redux';

import { DashboardSidebarPresentation } from './DashboardSidebarPresentation';

import { authenticationActions } from 'dataflow/distributorPortal/actions';

function mapStateToProps(state) {
    const { 
        userInfo,
    } = state.distributorPortal_authenticationReducers;

    return {
        userInfo,
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}

const DashboardSidebar = connect(mapStateToProps, mapDispatchToProps)(DashboardSidebarPresentation);

export default DashboardSidebar;